import { prepareCommonFiltersForApi } from "modules/common/utils/prepareCommonFiltersForApi";

import type { RefundsFilters } from "../../models/Filters";

export function prepareFiltersForApi(filters?: Partial<RefundsFilters>) {
  if (!filters) {
    return {};
  }

  const { currency, amountFrom, amountTo, ...commonFilters } = filters;

  const param = prepareCommonFiltersForApi(commonFilters);

  if (Array.isArray(currency) && currency.length > 0) {
    param["currency"] = currency;
  }

  if (Number.isInteger(amountFrom)) {
    param["amount[gte]"] = amountFrom;
  }

  if (Number.isInteger(amountTo)) {
    param["amount[lte]"] = amountTo;
  }

  return param;
}
